import * as React from 'react';
import { RouteComponentProps } from 'react-router';

import AccountMenu from 'src/components/AccountMenu';
import 'src/components/Menu/Menu.scss';
import { isMobile } from 'src/utils/responsiveHelpers';
import MobileMenu from 'src/components/SamsungOrderInvoiceSearchFormTable/MobileMenuForSamsungView';
import logo from 'src/assets/images/rp_logo.png';
import rpLogo from 'src/assets/rpLogo';
import i18n from 'src/translation/i18n';
import {
  ifLoggedIn,
  goToPartDetail,
  goToModelDetail,
  getSiteLanguage,
  samsungOrderInvoicePortalUrl
} from 'src/utils/navigation';
import { env } from 'src/shared/env';

interface IMenuProps extends RouteComponentProps {
  handleOnSubmitSearch(searchText: string): void;
  handleOnSearchSelectedPart(searchText: string): void;
  handleOnSearchSelectedModel(name: string, manufacturer: string): void;
  shouldShowSearchDropdown?: boolean;
  isMobile: boolean;
  scrolled: boolean;
  isLoggedIn: boolean;
  content: any;
}

export default class MenuForSamsungInvoiceView extends React.Component<
  IMenuProps,
  any
> {
  constructor(props: any) {
    super(props);

    this.state = {
      isMobile: isMobile(),
      actualUrl: '',
      resetSearchbar: { update: false, value: false },
      scrolled: false,
      showSarchbar: false
    };
  }

  public componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
    window.addEventListener('scroll', this.handlescroll);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
    window.removeEventListener('scroll', this.handlescroll);
  }

  public handlescroll = () => {
    const isTop = window.scrollY < 50;
    if (isTop !== true) {
      this.setState({ scrolled: true });
    } else {
      this.setState({ scrolled: false });
    }
  };

  public handleWindowSizeChange = () => {
    const isMob = isMobile();
    if (isMob !== this.state.isMobile) {
      this.setState({ isMobile: isMob });
    }
  };

  public componentDidMount() {
    const update = !this.state.resetSearchbar.update;
    this.setState({
      actualUrl: this.props.location,
      resetSearchbar: { update, value: true }
    });
  }

  public componentDidUpdate(prevProps: any, prevState: any) {
    if (prevState.actualUrl !== this.props.location) {
      const update = !this.state.resetSearchbar.update;
      this.setState({
        resetSearchbar: { update, value: true },
        actualUrl: this.props.location,
        showSarchbar: this.props.content ? true : false
      });
    }
  }

  private renderDesktop() {
    const language = window.localStorage.getItem('i18nextLng');
    let lng = 'en';
    if (language) {
      lng = language.split('-')[0];
    }
    return (
      <div className={this.state.scrolled ? 'nav scrolled' : 'nav'}>
        <div className="row no-gutters">
          <div
            className={
              lng === 'fr' ? 'rp-logo-div rp-logo-div-fr' : 'rp-logo-div'
            }
          >
            <div className="rp-logo-section">
              <MobileMenu />
              <div className="rpdevdummy-title">
                <a href={samsungOrderInvoicePortalUrl()} className="rp-logo">
                  <img src={rpLogo} alt="Reliable Parts logo" />
                  {/* <h1 className={i18n.language === 'fr' ? '' : ''}>
                    {i18n.t('common.housofMillionParts')}
                  </h1> */}
                </a>
              </div>
            </div>
          </div>
          <div className="rp-menu-section">
            <div id="rp-menu" className="no-select">
              <div className="rp-menu--menu-item">
                <AccountMenu
                  scrolled={this.state.scrolled || this.state.showSarchbar}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  private renderMobile() {
    return (
      <div id="rp-menu" className="rp-menu-mobile-view no-select">
        <div className="rp-logo-section">
          <MobileMenu />
          <div className="rpdevdummy-title">
            <a href="/us/" className="rp-logo">
              <img src={rpLogo} alt="Reliable Parts logo" />
              {/* <h1>{i18n.t('common.housofMillionParts')}</h1> */}
            </a>
          </div>
        </div>
        <div className="rp-menu-list-align">
          <div className="rp-menu--menu-item">
            <AccountMenu isMobile={true} />
          </div>
        </div>
      </div>
    );
  }

  public render() {
    return this.state.isMobile ? this.renderMobile() : this.renderDesktop();
  }

  private onSearchSelectedPart = (text: string) => {
    ifLoggedIn(() => goToPartDetail(text));
  };

  private onSearchSelectedModel = (name: string, manufacturer: string) => {
    ifLoggedIn(() => goToModelDetail(name, manufacturer));
  };
}
